<template>
    <div class="grid-container">
        <div class="grid-x grid-margin-x">
            <div class="cell small-12 medium-6">
                <header class="page_header">
                    <button type="button" class="back_btn show-for-small-only" @click="overlayClose">Назад</button>
                    {{ content.title }}
                </header>
            </div>
            <div class="cell small-12 medium-6 poll_text">
                <div v-html="content.text"></div>
                <p style="line-height:1"><span class="hint" v-html="content.sub_title"></span></p>
            </div>
            <div class="cell small-12 medium-6 large-6 second_col">
                <div class="show-for-small-only case_type">Бизнес</div>
                <ul class="poll_variants">
                    <svg width="35" height="240" class="case_type hide-for-small-only">
                        <text x="120" y="39" transform="translate(40) rotate(90 0 0)">Бизнес</text>
                    </svg>
                    <li v-for="(answer, idx) in businessCases" :key=idx>
                        <label>
                            <input type="checkbox" @change="addVariant(answer.id, selectedBusiness)" :disabled="isDisabled(answer.id, selectedBusiness)" v-if="!quizPassed">
                            <span class="input" v-if="!quizPassed"></span>
                            <span class="text">{{ parseTitle(answer.title).title }} <small v-if="answer.href"><router-link :to="`/cases/${answer.href}`" style="color:#e8a52a" @click.stop title="Перейти к делу">перейти к делу</router-link></small></span>
                            <span class="result" v-if="quizPassed && answer.result">
                                <CircleSector :radius=28 :progress=answer.animated_result :stroke=7 />
                                {{ answer.result }}%
                            </span>
                        </label>
                    </li>
                </ul>
            </div>
            <div class="cell small-12 medium-6 large-6 second_col">
                <div class="show-for-small-only case_type">Чиновники</div>
                <ul class="poll_variants">
                    <svg width="35" height="370" class="case_type hide-for-small-only">
                        <text x="185" y="39" transform="translate(40) rotate(90 0 0)">Чиновники</text>
                    </svg>
                    <li v-for="(answer, idx) in clerkCases" :key=idx>
                        <label>
                            <input type="checkbox" @change="addVariant(answer.id, selectedClerks)" :disabled="isDisabled(answer.id, selectedClerks)" v-if="!quizPassed">
                            <span class="input" v-if="!quizPassed"></span>
                            <span class="text">{{ parseTitle(answer.title).title }} <small v-if="answer.href"><router-link :to="`/cases/${answer.href}`" style="color:#e8a52a" @click.stop title="Перейти к делу">перейти к делу</router-link></small></span>
                            <span class="result" v-if="quizPassed && answer.result">
                                <CircleSector :radius=28 :progress=answer.animated_result :stroke=7 />
                                {{ answer.result }}%
                            </span>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
        <div class="grid-x grid-margin-x">
            <div class="cell">
                <button type="button" class="button send_results" @click="sendResults" :disabled="selectedBusiness.length == 0 && selectedClerks.length == 0" v-if="!quizPassed">Голосовать</button>
            </div>
        </div>
    </div>
</template>

<script>
import CircleSector from '../components/CircleSector'
import axios from 'axios'

export default {
    name: "Poll",
    props: { content:{ required:true, default:[] } },
    components: { CircleSector },
    data: () => ({
        selectedClerks:[], selectedBusiness:[], quizPassed
    }),
    created(){
        this.$root.$emit('setNav', false)
    },
    beforeMount(){
        let self = this

        if(self.quizPassed) self.getResults()
    },
    mounted(){
        let self = this
        if(self.quizPassed){
            setTimeout(() => {
                self.animateResults()
            }, 200);
        }
    },
    methods: {
        addVariant(idx, arr){
            let self = this
            if(arr.length < 3){
                if(arr.indexOf(idx) == -1){
                    arr.push(idx)
                } else {
                    arr.splice(arr.indexOf(idx),1)
                }
            } else if(arr.length == 3){
                arr.filter(el => {
                    if(el == idx) arr.splice(arr.indexOf(el),1)
                })
            }
        },
        isDisabled(idx, arr){
            return arr.length == 3 && arr.indexOf(idx) == -1
        },
        getResults(){
            let self = this

            return new Promise((res, rej) => {
                axios.get(`/quiz_result_json/${this.content.id}/`)
                .then(data => {
                    self.parseResults(data.data)
                    res()
                })
            })
        },
        sendResults(){
            let self = this
            self.quizPassed = true

            let params = new URLSearchParams();
            params.append( "_csrf", document.querySelector('[name="csrf-token"]').content )
            params.append( "id", this.content.id )
            params.append( "json", 1 )
            this.selectedBusiness.concat(this.selectedClerks).forEach(selected => params.append( "Question[results][answerIds][]", selected ))

            axios.post('/quiz_result/', params)
            .then(() => {
                self.getResults().then(() => {
                    setTimeout(() => {
                        self.animateResults()
                    }, 200)
                })
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        parseResults(data){
            let self = this
            
            data.forEach(result => {
                self.content.questions.answers.filter(answer => {
                    if(answer.id == result.id){
                        self.$set(answer, 'result', +parseFloat(result.percent).toFixed(1))
                        self.$set(answer, 'animated_result', 0)
                    }
                })
                self.content.questions.answers.filter(answer => {
                    if(!answer.result) self.$set(answer, 'result', 0)
                    if(!answer.result) self.$set(answer, 'animated_result', 0)
                })
            })
        },
        parseTitle(title){
            let splitTitle = title.split('|')[0]
            let subTitle = /\((.*)\)/.exec(splitTitle)
            try {
                subTitle = subTitle[1]
            } catch(e){
                subTitle = ''
            }
            return {title:splitTitle.split('(')[0], subTitle }
        },
        animateResults(){
            let self = this
            
            self.content.questions.answers.forEach(answer => {
                let initialResult = answer.result,
                    value = 0;
                let animationInterval;
                
                if(initialResult > 0){
                    animationInterval = setInterval(() => {
                        self.$set(answer, 'animated_result', value)
                        if(value >= initialResult) clearInterval(animationInterval)
                        value += 2
                    }, 50);
                }
            })
        },
        overlayClose(){
            this.$root.$emit('hideOverlay')
        }
    },
    computed: {
        businessCases(){
            return this.content.questions.answers.filter(answer => {
                let splitTitle = answer.title.split('|b') 
                if(splitTitle.length == 2){
                    slides.forEach((slide, idx) => {
                        if(splitTitle[0].toLowerCase().trim() == slide.title.toLowerCase().trim()) answer.href = idx
                    })
                    return answer
                }
            })
        },
        clerkCases(){
            return this.content.questions.answers.filter(answer => {
                let splitTitle = answer.title.split('|c') 
                if(splitTitle.length == 2){
                    slides.forEach((slide, idx) => {
                        if(splitTitle[0].toLowerCase().trim() == slide.title.toLowerCase().trim()) answer.href = idx
                    })
                    return answer
                }
            })
        }
    }
}
</script>

<style lang="scss">
    .poll_text { margin:$space*3 0 $space*2 }
    .case_type {
        position:absolute; left:-40px; top:0; opacity:.7;
        text { font-size:1.5rem; text-transform:uppercase; fill:transparent; stroke:#211d23; stroke-width:2px; font-family:$gorod; text-anchor:middle; letter-spacing:2px }

        @include small {
            position:relative; left:0; text-transform:uppercase; font-family:$gorod; color:$black; margin-top:$space*2;
        }
    }
    .second_col {
        padding-left:80px;
        @include small {
            padding-left:0;
        }    
    }
    .poll_variants {
        padding:0; margin:0; list-style:none; position:relative; overflow:visible;

        li {
            &:not(:first-child) { margin-top:$space/1.5 }
            label {
                display:flex; flex-direction:row; position:relative; cursor:pointer; font-family:$sans-serif; font-weight:600; font-size:fsz(1.1rem); color:$purple-gray; user-select:none;
                small { font-weight:400; font-size:fsz(1rem) }

                @include small {
                    line-height:1; font-size:.9rem;
                    small { font-size:.8rem }
                }

                a {
                    width:20px; height:20px; display:inline-block; text-indent:-9999px; background-image:url(data:image/svg+xml;base64,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); background-size:cover; background-repeat:no-repeat; background-position:left center;

                    @include small {
                        width:12px; height:12px;
                    }
                }
            }
            input {
                display:none;
                &:checked + .input {
                    &:after { opacity:1 }
                }
                &:disabled + .input { opacity:.2 }
            }
            .text {
                display:inline-block;
                @include small {
                    padding-top:7px;
                }    
            }
            .input {
                min-width:24px; height:24px; position:relative; margin-right:$space; float:left; margin-top:3px;
                &:before { content:""; position:absolute; top:0; left:0; width:100%; height:100%; border:2px solid $purple-gray; border-radius:100%; }
                &:after { content:""; position:absolute; top:50%; left:50%; transform:translate(-50%, -50%); width:30%; height:30%; background:$yellow; border-radius:100%; opacity:0; transition:opacity .2s ease } 
            }
            .result {
                width:24px; height:24px; position:relative; margin-left:auto; float:right; margin-top:2px; padding-left:38px; line-height:1.5;
                &:before { position:absolute; top:0; left:0; content:""; width:26px; height:26px; border:2px solid $black; border-radius:100%; }    
                
                svg {
                    position:absolute; top:-15px; left:-15px;
                    circle { stroke:$yellow }
                }

                @include small {
                    width:75px
                }
            }

            &:hover {
                .input:after { opacity:.5; transition:opacity .2s ease }
            }
        }
    }

    .flash { animation:pop .5s ease 1; display:inline-block }

    @keyframes pop {
        0% { transform:scale(1) }
        50% { transform:scale(1.5) }
        100% { transform:scale(1) }
    }

    .send_results { @include golden_button }
</style>